import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'job', en);

const JobPackConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Packing',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.JOB,
  permission: PERMISSION.READ,
  routes: [
    {
      path: '/job/pack',
      component: React.lazy(() => import('./JobPack')),
    },
  ],
};

export default JobPackConfig;
